<script setup lang="ts">
import { RouterView } from 'vue-router'
import Box from '@uiKit/elements/Box.vue'

// Pre-auth acquisition shell (signup). A full-viewport frame: the auth module's
// signup screen owns its top header, form column, and trust-panel column, so
// this shell just pins the viewport and paints the base surface.
</script>

<template>
  <Box is="main" class="signup-shell" block>
    <RouterView />
  </Box>
</template>

<style scoped>
.signup-shell {
  height: 100dvh;
  overflow: hidden;
  background: var(--p-surface-50);
}

@media (max-width: 992px) {
  .signup-shell {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }
}
</style>
